import { render, staticRenderFns } from "./CommonModalWithDivideDelivery.vue?vue&type=template&id=2c4777b8&lang=pug&"
import script from "./CommonModalWithDivideDelivery.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithDivideDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithDivideDelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports